<template>
  <div>
    <Modal
      v-model="modalCtrl" :title="title"
      footer-hide
    >
      <div style="margin-bottom: 10px;">
        <Button
          v-if="downloadUrl" :size="'small'"
          type="primary" :loading="isLoading"
          @click="downloadTpl"
        >
          下载模板
        </Button>
      </div>
      <div
        v-if="!uploadFinish" class="upload"
        @click="$refs.inputer.click()"
      >
        <div class="file-image"></div>
        <p>点击选择文件到此处上传</p>
        <input
          v-show="false" ref="inputer"
          :accept="fileType" type="file"
          @change="handleFileChange"
        >
      </div>
      <div class="sucess-upoad">
        <div v-if="uploadFinish == 'loading'">
          <Icon
            type="md-alert" size="50"
            style="color: #ff7d00; margin: 20px 0"
          />
          <p>处理中，请稍等...</p>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean
    },
    url: {
      type: String,
      required: true
    },
    fileType: {
      type: String,
      default: ''
    },
    downloadUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      uploadFinish: false,
      isLoading: false
    }
  },
  computed: {
    modalCtrl: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    // 下载模板
    downloadTpl() {
      const url = this.downloadUrl
      this.isLoading = true
      this.$exportGet(url).then(res => {
        this.isLoading = false
      })
    },
    handleFileChange() {
      const inputDOM = this.$refs.inputer
      if (inputDOM.files.length > 1) {
        this.$Message.error('只允许上传一份文件')
        inputDOM.value = null
        return
      }
      this.file = inputDOM.files[0]
      const ajaxData = new FormData()
      ajaxData.append('file', this.file)
      this.uploadFinish = 'loading'
      const url = this.url
      this.$post(url, ajaxData).then(res => {
        this.uploadFinish = true
        if (res.code == 0) {
          inputDOM.value = null
          this.$Message.success('上传成功')
          this.modalCtrl = false
          if (res.message) {
            this.$Message.info({
              content: res.message,
              duration: 0,
              closable: true
            })
          }
          this.$emit('ok', res.data)
        } else {
          this.$Message.error({
            content: res.message || '未知错误',
            duration: 5
          })
        }
        this.uploadFinish = false
      }).catch(() => {
        this.uploadFinish = false
        this.$Message.error('上传失败')
      })
    }

  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/globalStyle.scss";
.upload {
    width: 470px;
    height: 300px;
    border-radius: 10px;
    border: 1px solid #e5e6eb;
    // background: @color-fill-1;
    text-align: center;
    // color: @color-text-3;
    font-size: 12px;
    line-height: 20px;
    cursor: pointer;

    &:hover {
      background-color: #f1f1f1;
    }

    .file-image {
        width: 122px;
        height: 110px;
        margin: 50px 175px 24px;
        background-image: url("~@/assets/images/undraw_add_files.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }

    &>p:nth-of-type(1) {
        //   color: @color-text-1;
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
    }
}
.sucess-upoad {
    text-align: center;
    margin: auto;

    div {
        &>p:nth-of-type(1) {
            font-size: 16px;
            font-weight: 600;
        }

        &>p:nth-of-type(2) {
            margin-top: 3px;
            color: $labelColor;
        }

        .info-box {
            margin-top: 20px;
            background: #f7f8fa;

            p.info-title {
                font-weight: 600;
                height: 40px;
                line-height: 40px;
                border-bottom: 1px solid #e5e6eb;
            }

            div {
                padding: 13px 0;
                height: 170px;
                overflow-y: auto;

                .file-name-info {
                    margin-bottom: 5px;
                    display: block;
                    font-size: 12px;
                    color: #000;
                    text-align: left;
                    padding: 0 13px;
                    line-height: 22px;
                }

                .file-name-info-only {
                    display: block;
                    font-size: 12px;
                    color: $textColor;
                    text-align: center;
                    padding: 0 13px;
                    line-height: 22px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/common/uploadModal/uploadModal.vue